// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// APOLLO
// ANTD
import Button from 'components/common/Button';
import Row from 'components/common/Row';
import Col from 'components/common/Col';

// CONSTANTS & DESTRUCTURING
// ===================================

// STYLES
// ===================================
const styles = {
  container: {
    background: '#fff',
    minHeight: 300,
    maxWidth: '100%',
    width: 700,
    paddingTop: 30,
    margin: 'auto',
  },
  rowContainer: {
    width: 850,
    maxWidth: '90%',
    margin: 'auto',
    marginTop: 15,
  },
  button: {
    width: 205,
    height: 30,
    borderRadius: 30,
  },
};

const MaxWidthContainer = styled.div`
  max-width: 100%;
`;

const Paragraph = ({ content }) => (
  <p className="mt2" style={{ fontSize: '18px' }} dangerouslySetInnerHTML={{ __html: content }} />
);

class PlanHeader extends React.Component {
  state = {
    showDemo: false,
  };

  onDemo = () => {
    this.setState({ showDemo: true });
  };

  onGetQuote = () => {
    // open the quote modal
    this.props.history.push('/contact');
    this.setState({ visible: true });
  };

  renderButtonArea = () => (
    <Row style={styles.rowContainer}>
      <Col xs={24} style={{ textAlign: 'center' }}>
        <Button onClick={this.onGetQuote}>GET MORE INFORMATION</Button>
      </Col>
    </Row>
  );

  render() {
    const { plan } = this.props;
    const { title, description, remark } = plan;

    if (this.state.showDemo) {
      return (
        <Row type="flex" align="middle" justify="center" style={styles.container}>
          <div>
            <div className="center">
              <h1>{title}</h1>
              <Paragraph content={description} />
              <Paragraph content={remark} />
            </div>
            {/* <DemoContent plan={this.props.plan} data={this.props.data} /> */}
          </div>
        </Row>
      );
    }

    return (
      <Row type="flex" align="middle" justify="center" style={styles.container}>
        <MaxWidthContainer>
          <div className="center">
            <h1>{title}</h1>
            <Paragraph content={description} />
            <Paragraph content={remark} />
          </div>
          {this.renderButtonArea()}
        </MaxWidthContainer>
      </Row>
    );
  }
}

PlanHeader.defaultProps = {
  shoppingCart: [],
};

export default PlanHeader;



// WEBPACK FOOTER //
// ./src/routes/app-dashboard-preview/PlanHeader/index.js